import * as React from 'react';
import styled from 'styled-components';
import { Card, CardContent, CardTitle, InputFile, Radio, RadioGroup } from '../../../Components';
import { ValidationError } from '../../../Store';
import { DepositoModel, SituacaoDoDeposito } from '../../../Store/Deposito';

interface IProps {
  handleSubmit: (...args: any[]) => any;
  file: File | null;
  deposito: DepositoModel;
  validationError: ValidationError<{ file: File | null }>;
  handleChange: (...args: any[]) => any;
  handleTipoChange: (...args: any[]) => any;
}

const DepositoContainer = styled.div`
  display: grid;
  grid-column-gap: 1rem;
  justify-content: stretch;
`;

export const DepositoCard: React.FC<IProps> = (
  { file, deposito, validationError, handleSubmit, handleChange, handleTipoChange }: IProps) => {
    const [selectedValue, setSelectedValue] = React.useState('monografia'); // Valor padrão

    React.useEffect(() => {
      handleTipoChange("monografia")
    },[])

    const handleRadioChange = (value: string) => {
      setSelectedValue(value);
      handleTipoChange(value);
    };

    return (
    <Card>
      <CardTitle>
        Depósito
      </CardTitle>
      <CardContent>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <DepositoContainer>
            <InputFile
              label="Anexar arquivo"
              accept="application/pdf"
              disabled={deposito && deposito.conteudoDoArquivo != null && [
                SituacaoDoDeposito.aprovado,
                SituacaoDoDeposito.pendente
              ].includes(deposito.situacao)}
              hasError={validationError && validationError.file != undefined}
              errorMessage={validationError && validationError.file}
              onChange={handleChange}
            />
          </DepositoContainer>
          <RadioGroup
            name="tipoTrabalho"
            selectedValue={selectedValue}
            onChange={handleRadioChange}
          >
            <Radio value="monografia" label="Monografia" />
            <Radio value="artigo" label="Artigo" />
          </RadioGroup>
        </form>
      </CardContent>
    </Card >
  );
};